import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorLayout from '../../components/error/ErrorLayout';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ErrorLayout
      code={t('errors.notFound.code')}
      title={t('errors.notFound.title')}
      message={t('errors.notFound.message')}
      icon="warning"
    >
      <div className="error-actions">
        <Link to="/" className="btn btn-primary">
          {t('errors.notFound.backHome')}
        </Link>
        <button 
          className="btn btn-secondary" 
          onClick={() => navigate(-1)}
        >
          {t('errors.notFound.previousPage')}
        </button>
      </div>
    </ErrorLayout>
  );
}
